import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const useSocket = () => {
    const context = useContext(SocketContext);
    if (context === undefined) {
        throw new Error('useSocket must be used within a SocketProvider');
    }
    return context;
};

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const { user } = useAuth();

    useEffect(() => {
        // Only connect if user is logged in
        if (user) {
            // Use the REACT_APP_API_URL but strip '/api' to get base URL
            const apiUrl = (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== 'http://localhost:5000/api')
                ? process.env.REACT_APP_API_URL
                : 'https://drvivara.cloud/api';
            const socketUrl = apiUrl.replace('/api', '');

            const savedToken = localStorage.getItem('token');
            const validToken = savedToken && savedToken !== 'null' && savedToken !== 'undefined' && savedToken.length > 10 ? savedToken : null;

            const newSocket = io(socketUrl, {
                reconnection: true,
                reconnectionAttempts: 10,
                reconnectionDelay: 1000,
                transports: ['websocket', 'polling'],
                auth: {
                    token: validToken
                }
            });

            newSocket.on('connect', () => {
                console.log("✅ Socket connected:", newSocket.id);
                const userId = user._id || user.id;
                console.log("🔗 Joining personal room:", userId);
                newSocket.emit('join_room', userId);
            });

            newSocket.on('connect_error', (err) => {
                console.error("❌ Socket connection error:", err.message);
                // Retry logic is handled by socket.io 'reconnection' option
            });

            newSocket.on('disconnect', (reason) => {
                console.warn("⚠️ Socket disconnected:", reason);
                if (reason === 'io server disconnect') {
                    // the disconnection was initiated by the server, you need to manually reconnect
                    newSocket.connect();
                }
            });

            setSocket(newSocket);

            return () => {
                newSocket.disconnect();
            };
        } else {
            setSocket(null);
        }
    }, [user]);

    return (
        <SocketContext.Provider value={{ socket }}>
            {children}
        </SocketContext.Provider>
    );
};

